import { replaceInPageHistoryUrl } from "@/main/navigation/NavigationHistoryState";

// Resume-an-intended-series-follow helper (round 38 D7, `SERIES-23`).
//
// The series twin of `react/group/groupJoinIntent.ts`, and deliberately the same shape: a signed-out
// visitor who presses Follow on a series is gated behind account access, and the intended follow is
// carried as a `?follow=1` continuation to the series' own page. On arrival the page header's
// `SeriesButtons` consumes it ONCE and completes the follow (the follow stays authorization-checked
// server-side). The param is an instruction, not a state, so it is stripped with
// `replaceInPageHistoryUrl(..., "consume-one-shot")` (rule 33): a re-render or a Back onto the entry
// never follows again.

const FOLLOW_PARAM = "follow";

function stripTrailingSlashes(path: string): string {
    return path.replace(/\/+$/, "");
}

/**
 * True when the current URL carries `?follow=1` for THIS series' page, after stripping the param. The
 * slug-in-path guard means a stray param on another route (a card list, the insights page) never acts,
 * and another series' instance leaves it for the right one.
 */
export function consumeSeriesFollowIntent(seriesSlug: string): boolean {
    if (typeof window === "undefined" || !seriesSlug) {
        return false;
    }

    const url = new URL(window.location.href);
    if (url.searchParams.get(FOLLOW_PARAM) !== "1") {
        return false;
    }

    if (stripTrailingSlashes(url.pathname) !== `/series/${seriesSlug}`) {
        return false;
    }

    url.searchParams.delete(FOLLOW_PARAM);
    replaceInPageHistoryUrl(`${url.pathname}${url.search}${url.hash}`, "consume-one-shot");
    return true;
}

/** The same-site relative continuation that resumes a follow on the series' own page. */
export function buildSeriesFollowContinuationUrl(seriesSlug: string): string {
    return `/series/${seriesSlug}?${FOLLOW_PARAM}=1`;
}
